/**
 * Given a selectable cell, setup the row.
 * @param {HTMLTableCellElement} $cell
 */
function setupSelectableTableRowFromCell($cell) {
	if (!$cell.classList.contains('ams-cpd-table-cell--selector')) {
		return;
	}

	if ($cell.hasAttribute('data-ams-cpd-table-cell--selector-setup')) {
		return;
	}

	$cell.dataset.amsCpdTableCellSelectorSetup = 'true';

	const $row = $cell.closest('.ams-cpd-table-row');

	if (!$row) {
		return;
	}

	$row.addEventListener('click', event => {
		// If it's not the input, a link, or a button, bail.
		const $ignoreTarget = event.target.closest('a, button, input[type=checkbox]');
		if ($ignoreTarget) {
			return;
		}

		$cell.querySelector('[type=checkbox]').checked = !$cell.querySelector('[type=checkbox]').checked;
		// Dispatch a change event.
		$cell.querySelector('[type=checkbox]').dispatchEvent(new Event('change', {bubbles: true}));
	});

	$row.classList.add('ams-cpd-table-row--selectable');

}

// Set up selectable table rows.
document.addEventListener('DOMContentLoaded', () => {
	const $candidateCells = document.querySelectorAll('.ams-cpd-table tbody .ams-cpd-table-cell--selector');

	if ($candidateCells.length === 0) {
		return;
	}

	$candidateCells.forEach(setupSelectableTableRowFromCell);
});
